import { render, staticRenderFns } from "./OfficeNew.vue?vue&type=template&id=384d3a87&scoped=true&"
import script from "./OfficeNew.vue?vue&type=script&lang=js&"
export * from "./OfficeNew.vue?vue&type=script&lang=js&"
import style0 from "./OfficeNew.vue?vue&type=style&index=0&id=384d3a87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384d3a87",
  null
  
)

export default component.exports